import { createSlice } from "@reduxjs/toolkit";

const notificationSlice = createSlice({
    name: "notifications",
    initialState: {
        orderNotifications: [],
    },
    reducers: {
        addOrderNotification: (state, action) => {
            state.orderNotifications.push(action.payload);
        },
        clearOrderNotifications: (state) => {
            state.orderNotifications = [];
        },
        markNotificationAsRead: (state, action) => {
            const index = state.orderNotifications.findIndex(n => n.id === action.payload);
            if (index !== -1) {
                state.orderNotifications[index].read = true;
            }
        },
        markAllNotificationsAsRead: (state) => {
            state.orderNotifications = state.orderNotifications.map((n) => ({
                ...n,
                read: true,
            }));
        },
        removeOrderNotification: (state, action) => {
            state.orderNotifications = state.orderNotifications.filter(
                (notification) => notification.id !== action.payload
            );
        },
    },
});

export const {
    addOrderNotification,
    removeOrderNotification,
    clearOrderNotifications,
    markNotificationAsRead,
    markAllNotificationsAsRead,
} = notificationSlice.actions;

export default notificationSlice.reducer;
